import React, { useEffect, useState } from "react";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Footer from "../../examples/Footer";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import MDButton from "../../components/MDButton";
import data from "../../layouts/dashboard/components/Projects/data";
import {
    IconButton,
    Menu,
    MenuItem,
} from "@mui/material";
import MDTypography from "../../components/MDTypography";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RefreshIcon from "@mui/icons-material/Refresh";
import AllControlConfig from "./components/allcontrolconfig";
import GenericForm from "../dialog/genericform";
import {getFields} from "../dialog/formfields";
import {useNavigate} from "react-router-dom";
import DataTableConfig from "../Tables/DataTableConfig";
import Endpoints from "../utils/endpoints";
import toast from "react-hot-toast";
import useConfigApi from "../utils/configapi";


function Parameterconfig() {
    const { controlConfigColumns } = data();
    const { controlConfigFields } = getFields();
    const [controlConfig, setControlConfig] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeRow, setActiveRow] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [dialogData, setDialogData] = React.useState(null);
    const [dialogMode, setDialogMode] = React.useState("edit");
    const [dialogTitle, setDialogTitle] = React.useState("Create ControlConfig");
    const navigate = useNavigate();
    const api = useConfigApi();
    const [controlConfigFieldsModified, setControlConfigFieldsModified] = useState([]);

    const handleMenuOpen = (event, row) => {
        setAnchorEl(event.currentTarget);
        setActiveRow(row);
    };

    const openModal = () => {
        setDialogMode("create");
        setDialogData({});
        setModalOpen(true);
        setDialogTitle("Create ControlConfig");
    };

    const closeModal = () => {
        setModalOpen(false);
        setDialogData(null);
    };


    const handleMenuClose = () => {
        setAnchorEl(null);
        setActiveRow(null);
    };


    const handleActionClick = (action: string, item) => {
        console.log(`${action} clicked for:`, activeRow, item);
        console.log(`${action}`, item)
        if(action === 'View'){
            setModalOpen(true);
            setDialogMode("view");
            setDialogTitle("View ControlConfig");
            setDialogData({
                ...activeRow,
                controlType: activeRow.groupConfig.grpId,
                controlId: activeRow.groupConfig.grpId
            });
        } else if (action === 'Edit') {
            setModalOpen(true);
            setDialogMode("edit");
            setDialogTitle("Edit ControlConfig");
            setDialogData({
                ...activeRow,
                controlType: activeRow.groupConfig.grpId,
                controlId: activeRow.groupConfig.grpId
            });

        } else if(action === 'viewDevices') {
            console.log(`${item.slNo}`);
            navigate(`/control-config-view/`, {
                state: { item },
            });
        } else if (action === 'Delete') {
            setModalOpen(true);
            setDialogMode("delete");
            setDialogTitle("Delete ControlConfig");
            setDialogData(activeRow);
        }
        handleMenuClose();
    };

    const handleDialogSubmit = (formData) => {
        console.log("Submitted data:", formData, dialogMode);
        // Call your API here
        const selectedControlType = controlConfigFieldsModified
            .find(field => field.name === "controlType")
            ?.options.find(opt => opt.value === formData.controlType);

        const reqObj = {
            controlName: formData.controlName,
            controlType: selectedControlType?.label,
            orgId: "",
            groupId: formData.controlId,
            slNo: formData.slNo
        }
        if (dialogMode === "create") {
            // Handle create logic here
            api.post(Endpoints.controlConfig.createReadUpdate, reqObj)
                .then((response) => {
                    toast.success("Control config successfully created.");
                    fetchControlConfig().catch(console.error); // Fetch the latest data after creation
                })
                .catch((error) => {
                    const responseMessage = error?.response?.data?.responseMessage;
                    if (responseMessage.includes("duplicate key value") &&
                        responseMessage.includes("control_name")) {
                        toast.error("Config name already exists.");
                    } else {
                        toast.error("Internal error occurred while creating.");
                    }

                });
        } else if (dialogMode === "edit") {
            api.put(Endpoints.controlConfig.createReadUpdate, reqObj)
                .then((response) => {
                    toast.success("Control config successfully updated.");
                    fetchControlConfig().catch(console.error); // Fetch the latest data after editing
                })
                .catch((error) => {
                    const responseMessage = error?.response?.data?.responseMessage;
                    if (responseMessage.includes("duplicate key value") &&
                        responseMessage.includes("control_name")) {
                        toast.error("Config name already exists.");
                    } else {
                        toast.error("Internal error occurred while updating.");
                    }

                });
        }
    };

    const handleDialogDelete = (formData) => {
        if (!formData.slNo) {
            toast.error("Missing Serial Number for deletion.");
            return;
        }
        api.delete(Endpoints.controlConfig.deleteBySlNo(formData.slNo))
            .then(() => {
                toast.success("Control config successfully deleted.");
                fetchControlConfig().catch(console.error);;
            })
            .catch(() => {
                toast.error("Error deleting device config.");
            });
    };

    useEffect(() => {
        fetchControlConfig().catch(console.error);
    }, []);

    const fetchControlConfig = async () => {
        try {
            // 1. Fetch Control Config
            const controlConfigResponse = await api.get(Endpoints.controlConfig.createReadUpdate);
            const controlConfig = controlConfigResponse?.data?.data || [];

            // 2. Fetch Groups
            const groupsResponse = await api.get(Endpoints.groups.getAll(false));
            const groups = groupsResponse?.data?.data || [];

            // 3. Format Table Data
            const modifiedData = controlConfig.map((item, index) => {
                console.log(item)
                const action = (
                    <>
                        <MDTypography
                            display="inline"
                            color="info"
                            sx={{
                                borderBottom: "1px solid #2196F3",
                                paddingBottom: "1px",
                                fontSize: "14px",
                                textTransform: "capitalize",
                                fontWeight: "light",
                                cursor: "pointer",
                                marginRight: 1,
                            }}
                            onClick={() => handleActionClick("viewDevices", item)}
                        >
                            Click here to view
                        </MDTypography>

                        <IconButton onClick={(e) => handleMenuOpen(e, item)}>
                            <MoreHorizIcon />
                        </IconButton>
                    </>
                );
                const controlId = item.groupConfig.grpId;

                return { ...item, action,controlId };
            });
            setControlConfig(modifiedData);

            // 4. Prepare Options for Select Field
            const groupOptions = groups.map((group) => ({
                label: group.grpConfigName,  // adjust if needed
                value: group.grpId
            }));

            setControlConfigFieldsModified(controlConfigFields.map(field =>
                field.name === "controlType"
                    ? { ...field, options: groupOptions}
                    : field
            ));

        } catch (error) {
            toast.error("Error while fetching devices or group data.");
            console.error(error);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {/*{!showAllConfig ? (*/}
            {/*    */}
            {/*) : (*/}
            {/*    <AllControlConfig onBack={handleBack} />*/}
            {/*)}*/}
            <>
                <MDBox mt={6} mb={3}>
                    <Grid container spacing={3} justifyContent="center">
                        <Grid container justifyContent="flex-end">
                            <MDButton
                                variant="gradient"
                                onClick={openModal}
                                color="info"
                                sx={{ mr: 3, mb: 1.5 }}
                            >
                                Create New Control
                            </MDButton>
                        </Grid>
                        <Grid item xs={12} lg={12}>
                            <DataTableConfig
                                table={{ columns: controlConfigColumns, rows: controlConfig }}
                                showTotalEntries={true}
                                isSorted={true}
                                noEndBorder
                                entriesPerPage={true}
                                canSearch={true}
                            />
                        </Grid>
                    </Grid>
                </MDBox>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    onClick={handleMenuClose}
                >
                    <MenuItem onClick={() => handleActionClick("View")}>
                        <IconButton size="small">
                            <i className="material-icons">visibility</i>
                        </IconButton>
                        View
                    </MenuItem>
                    <MenuItem onClick={() => handleActionClick("Edit")}>
                        <IconButton size="small">
                            <EditIcon fontSize="small" />
                        </IconButton>
                        Edit
                    </MenuItem>
                    <MenuItem onClick={() => handleActionClick("Delete")}>
                        <IconButton size="small" color="error">
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                        Delete
                    </MenuItem>
                    {/*<MenuItem onClick={() => handleActionClick("Sync")}>*/}
                    {/*    <IconButton size="small" color="error">*/}
                    {/*        <RefreshIcon fontSize="small" />*/}
                    {/*    </IconButton>*/}
                    {/*    Sync*/}
                    {/*</MenuItem>*/}
                </Menu>

                <GenericForm
                    open={isModalOpen}
                    handleClose={closeModal}
                    title={dialogTitle}
                    fields={controlConfigFieldsModified}
                    onSubmit={handleDialogSubmit}
                    onDelete={handleDialogDelete}
                    initialData={dialogData}
                    mode={dialogMode}
                    useDialog={true}
                    maxWidth="sm"
                />
            </>
            <Footer />
        </DashboardLayout>
    );
}

export default Parameterconfig;
